












































































































import Vue from "vue";
import { ref, onMounted, Ref } from "@vue/composition-api";
import { DrillDownMenuItem } from "./drilldown-menu.state";
import PremiumBtn from "@/components/premium/PremiumBtn.vue";
export default Vue.extend({
  name: "DDMenu",
  props: ["items", "isChild"],
  components: {
    PremiumBtn,
  },
  setup(_, { emit }) {
    const currentOpenMenu = ref(-1);
    const ddMenu: Ref<HTMLElement | null> = ref(null);

    const onAction = (p: { item: DrillDownMenuItem; index: number }) => {
      if (!p.item.isCategory) {
        emit("onAction", p);
      }
    };

    const onHover = (p: { item: DrillDownMenuItem; index: number }) => {
      if (p.item.isCategory && !p.item.isPremium) {
        currentOpenMenu.value = p.index;
      } else {
        currentOpenMenu.value = -1;
      }
    };

    const isOverflowY = ref(false);

    onMounted(() => {
      // check top left right bottom
      // fix position if needed
      if (ddMenu.value) {
        const { bottom } = ddMenu.value.getBoundingClientRect();
        isOverflowY.value = bottom > window.innerHeight;
      }
    });

    return {
      onAction,
      onHover,
      currentOpenMenu,
      ddMenu,
      isOverflowY,
    };
  },
});
